import { useMemo } from 'react'

import { Construction } from '@mui/icons-material'
import { Typography } from '@mui/material'
import { OrgEnvironment } from '@nativewaves/nw-cloud-sdk/org'
import { ColumnDef } from '@tanstack/react-table'
import { useTranslation } from 'react-i18next'

import { CopyId } from '@shared/components/Table/Fields'
import { ButtonLink } from 'components/LinkedMUIComponents'
import { environmentRoute } from 'pages/NWPlatform'
import { environmentsOverviewRoute } from 'pages/NWPlatform/Organizations/Organization/Environments'

export const useColumns = () => {
  const { t } = useTranslation(['common', 'domain'])

  return useMemo<ColumnDef<OrgEnvironment>[]>(
    () => [
      {
        accessorKey: 'name',
        header: t('name'),
        meta: {
          sizing: {
            minWidth: 300,
            px: 2,
          },
        },
        cell: ({ getValue }) => (
          <Typography variant="inherit" noWrap>
            {getValue<string>()}
          </Typography>
        ),
      },
      {
        accessorKey: 'id',
        header: t('id'),
        meta: {
          sizing: {
            width: 200,
            px: 2,
          },
        },
        cell: ({ getValue }) => <CopyId id={getValue<string>()} />,
      },
      {
        id: '_manage_environment',
        header: () => null,
        meta: {
          sizing: {
            width: 240,
          },
          align: 'center',
        },
        cell: ({ row }) => (
          <ButtonLink
            size="small"
            startIcon={<Construction />}
            from={environmentsOverviewRoute.fullPath}
            to={environmentRoute.to}
            params={{ environmentId: row.original.id }}
          >
            {t('domain:My.Organization.manageEnvironment')}
          </ButtonLink>
        ),
      },
    ],
    [t],
  )
}
